import { render, staticRenderFns } from "./trainPlay.vue?vue&type=template&id=9472fa24&scoped=true"
import script from "./trainPlay.vue?vue&type=script&lang=js"
export * from "./trainPlay.vue?vue&type=script&lang=js"
import style0 from "./trainPlay.vue?vue&type=style&index=0&id=9472fa24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9472fa24",
  null
  
)

export default component.exports